import { render, staticRenderFns } from "./Rapporti.vue?vue&type=template&id=210ea830&scoped=true&"
import script from "./Rapporti.vue?vue&type=script&lang=js&"
export * from "./Rapporti.vue?vue&type=script&lang=js&"
import style0 from "./Rapporti.vue?vue&type=style&index=0&id=210ea830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ea830",
  null
  
)

export default component.exports